<template>
  <div class="d-flex" style="gap: 12px;">
    <input class="form-control" ref="maskedInputRef">

    <date-range-picker
      class="input-datetime"
      v-model="datetime"
      :single-date-picker="true"
      :time-picker="true"
      :min-date="new Date()"
      :time-picker24-hour="true"
      :time-picker-increment="1"
      :locale-data="localeData"
      :ranges="false"
      opens="left">
      <template #input>
        <i class="glyphicon glyphicon-calendar fa fa-calendar"></i>
      </template>
    </date-range-picker>
  </div>
</template>

<script>
import DateRangePicker from 'vue2-daterange-picker'
export default {
  name: "InputDatetime",
  components: {
    DateRangePicker
  },
  model: {
    prop: 'value',
    event: 'update',
  },
  props: {
    value: {
      type: String,
      default: null,
    },
  },
  data() {
    return {
      inputDatetime: '',
      outputFormat: 'YYYY-MM-DD HH:mm',
      iMask: null,
      localeData: {
        format: 'yyyy-mm-dd HH:MM:ss',
        firstDay: 1,
        daysOfWeek: ['Вс', 'Пд', 'Вт', 'Ср', 'Чт', 'Пт', 'Сб'],
        monthNames: ['Янв', 'Фев', 'Мар', 'Апр', 'Май', 'Июн', 'Июл', 'Авг', 'Сен', 'Окт', 'Ноя', 'Дек'],
      }
    };
  },
  watch: {
    datetime(value) {
      if (this.iMask && value.startDate) {
        this.iMask.value = moment(value.startDate).format(this.outputFormat);
      }
    },
  },
  mounted() {
    if (IMask) {
      this.iMask = IMask(this.$refs.maskedInputRef, {
        mask: Date,
        lazy: false,
        pattern: this.outputFormat,

        format: date => {
          return moment(date).format(this.outputFormat);
        },
        parse: str => {
          return moment(str, this.outputFormat);
        },

        blocks: {
          YYYY: {
            mask: IMask.MaskedRange,
            from: new Date().getFullYear(),
            to: new Date().getFullYear() + 5,
          },
          MM: {
            mask: IMask.MaskedRange,
            from: 1,
            to: 12
          },
          DD: {
            mask: IMask.MaskedRange,
            from: 1,
            to: 31
          },
          HH: {
            mask: IMask.MaskedRange,
            from: 0,
            to: 23
          },
          mm: {
            mask: IMask.MaskedRange,
            from: 0,
            to: 59
          }
        }
      });

      this.iMask.on('accept', () => {
        this.datetime = {
          startDate: null,
        };
      });

      this.iMask.on('complete', () => {
        this.datetime = {
          startDate: moment(this.iMask.value, this.outputFormat)
        }
      });
    }
  },
  beforeDestroy() {
    if (this.iMask) {
      this.iMask.off('accept');
      this.iMask.off('complete');
      this.iMask.destroy();
      this.iMask = null;
    }
  },
  computed: {
    datetime: {
      set(value) {
        if (value && value.startDate) {
          this.$emit('update', moment(value.startDate).format());
          return;
        }

        this.$emit('update', null);
      },
      get() {
        return {
          startDate: this.value ? new Date(this.value) : null,
          endDate: this.value ? new Date(this.value) : null,
        };
      },
    }
  }
}
</script>

<style>
  .input-datetime {
    min-width: auto !important;
  }
</style>


// WEBPACK FOOTER //
// src/components/custom-fields/src/InputDatetime.vue